export default __webpack_public_path__ + "static/media/kdabra-compact-light.7e6f41e3.svg";